/** Convert snake_case or kebab-case to Title Case */
export function humanize(name: string): string {
	return name.replace(/[_-]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
